/**
 * 设计规范的 TS 版（颜色引用 theme.css 的 CSS 变量），给 style={{}} 内联样式用。
 * 日程类别、卡牌稀有度的配色与 iOS CategoryStyle / RarityStyle 一致（学习模块的配色在注册表，见 activities/registry.ts）。
 */

export const C = {
  ink: "var(--kp-ink)",
  inkSoft: "var(--kp-ink-soft)",
  inkMuted: "var(--kp-ink-muted)",
  bg: "var(--kp-bg)",
  surface: "var(--kp-surface)",
  chip: "var(--kp-chip)",
  line: "var(--kp-line)",
  disabled: "var(--kp-disabled)",
  accent: "var(--kp-accent)",
  accentShadow: "var(--kp-accent-shadow)",
  accentSoft: "var(--kp-accent-soft)",
  gold: "var(--kp-gold)",
  starStroke: "var(--kp-star-stroke)",
  dark: "var(--kp-dark)",
  dark2: "var(--kp-dark2)",
  dark3: "var(--kp-dark3)",
  link: "var(--kp-link)",
  purple: "var(--kp-purple)",
  purpleSoft: "var(--kp-purple-soft)",
  purpleBright: "var(--kp-purple-bright)",
  success: "var(--kp-success)",
  successSoft: "var(--kp-success-soft)",
  danger: "var(--kp-danger)",
  dangerSoft: "var(--kp-danger-soft)",
  honey: "var(--kp-honey)",
  switchOff: "var(--kp-switch-off)",
  dashed: "var(--kp-dashed)",
} as const;

export const Radius = { panel: 28, card: 20, item: 16, small: 12 } as const;

export interface CategoryStyle {
  name: string;
  /** 卡片底色 */
  tint: string;
  /** 卡片文字 / 图标色 */
  ink: string;
  /** 图例小方块、月视图色条 */
  dot: string;
  /** 强调（进度条、"现在"标签） */
  strong: string;
}

const CATEGORY: Record<string, CategoryStyle> = {
  course: { name: "课程", tint: "var(--kp-course-tint)", ink: "var(--kp-course-ink)", dot: "var(--kp-course-dot)", strong: "var(--kp-course-strong)" },
  after_school: { name: "课后", tint: "var(--kp-after-tint)", ink: "var(--kp-after-ink)", dot: "var(--kp-after-dot)", strong: "var(--kp-after-strong)" },
  other: { name: "其它", tint: "var(--kp-other-tint)", ink: "var(--kp-other-ink)", dot: "var(--kp-other-dot)", strong: "var(--kp-other-strong)" },
};

/** category 取值：course / after_school / other */
export function categoryStyle(category: string | null | undefined): CategoryStyle {
  return CATEGORY[category ?? ""] ?? CATEGORY.other!;
}

export const CATEGORY_KEYS = ["course", "after_school", "other"] as const;

export interface RarityStyle {
  name: string;
  tint: string;
  ink: string;
}

const RARITY: Record<string, RarityStyle> = {
  legendary: { name: "传说", tint: "#FFF0C2", ink: "#8A5A00" },
  epic: { name: "史诗", tint: "#EFE6FA", ink: "#6A3DB0" },
  rare: { name: "稀有", tint: "#E4EDFC", ink: "#1F4FA8" },
  common: { name: "普通", tint: "#EEF0F3", ink: "#5B6270" },
};

export function rarityStyle(rarity: string | null | undefined): RarityStyle {
  return RARITY[rarity ?? ""] ?? RARITY.common!;
}

export const RARITY_KEYS = ["common", "rare", "epic", "legendary"] as const;

